import { Component, Output, EventEmitter, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { LabeledMenuComponent, MenuItem } from '@mode/shared/ui';
import { FrequencyType } from '@mode/shared/schedules/contract';

interface cadenceMenuItem extends MenuItem {
  value: FrequencyType;
}

@Component({
  standalone: true,
  imports: [CommonModule, MatLegacyMenuModule, LabeledMenuComponent],
  selector: 'mode-cadence-selector',
  templateUrl: './cadence-selector.component.html',
  styleUrls: ['./cadence-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadenceSelectorComponent implements OnInit {
  @Input() cadence: FrequencyType = 'daily';
  @Output() cadenceChange = new EventEmitter<string>();

  public options: cadenceMenuItem[] = [
    {
      name: '15 minutes',
      value: 'every_15_minutes',
    },
    {
      name: '30 minutes',
      value: 'every_30_minutes',
    },
    {
      name: 'Hour',
      value: 'hourly',
      divider: true,
    },
    {
      name: 'Day',
      value: 'daily',
      desc: 'Monday - Sunday',
    },
    {
      name: 'Weekday',
      value: 'weekday',
      desc: 'Monday - Friday',
    },
    {
      name: 'Week',
      value: 'weekly',
      desc: 'Mondays',
    },
    {
      name: 'Month',
      value: 'monthly',
      desc: `1st of the month`,
    },
  ];

  public selected: MenuItem | null = null;

  ngOnInit(): void {
    this.setSelected(this.cadence);
  }
  setSelected(filter: FrequencyType) {
    this.options.map((option: MenuItem) => {
      if (option.value === filter) {
        this.selected = option;
      }
    });
  }

  onCadenceChange(option: cadenceMenuItem) {
    this.setSelected(option.value);
    this.cadenceChange.emit(option.value);
  }
}
